var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMessageFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12607 1.50412C4.86692 1.13012 5.69856 0.956055 6.52746 1.00179C7.69222 1.06605 8.79236 1.55768 9.61722 2.38254C10.4421 3.20741 10.9337 4.30754 10.998 5.47231C10.9985 5.48146 10.9987 5.49062 10.9987 5.49978C10.9987 6.29687 10.8851 7.10212 10.4956 7.8737C10.1014 8.66199 9.49565 9.32503 8.74604 9.78861C7.99631 10.2523 7.13234 10.4981 6.25084 10.4985C5.58347 10.5002 4.92427 10.3594 4.31703 10.0865L1.6577 10.9729C1.47848 11.0327 1.2809 10.986 1.14731 10.8525C1.01373 10.7189 0.967089 10.5213 1.02683 10.3421L1.91327 7.68274C1.64038 7.07553 1.49957 6.41637 1.50123 5.74903C1.50168 4.8675 1.74749 4.00348 2.21116 3.25373C2.67473 2.50412 3.33777 1.89832 4.12607 1.50412Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageFilled);
export default __webpack_public_path__ + "static/media/icon-message-filled.7f9c5ba4bf434a50fa0e5dace3f40e7b.svg";
export { ForwardRef as ReactComponent };